import { useCallback, useEffect, useRef } from "react";
import { APP_LINK } from "~/_constants";
import { EMobileAppDeeplink } from "~/_enums/EMobileAppDeeplink";
import { EPlatform } from "~/_enums/EPlatform";
import { detectMobilePlatform } from "~/_utils/mobile/detectMobilePlatform";

const TIMEOUT_MS = 300;

/**
 * @see https://stackoverflow.com/a/63170977
 */
const openWindow = (href: string) => {
  const a = document.createElement("a") as HTMLAnchorElement;
  a.style.setProperty("display", "none");
  a.setAttribute("href", href);
  a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**
 * @see https://docs.tosspayments.com/blog/how-to-use-deep-links#%EC%95%B1%EC%9D%B4-%EC%84%A4%EC%B9%98%EB%8F%BC%EC%9E%88%EC%A7%80-%EC%95%8A%EC%9D%84-%EB%95%8C-%EC%98%88%EC%99%B8-%EC%B2%98%EB%A6%AC%EB%A5%BC-%ED%95%98%EA%B3%A0-%EC%8B%B6%EC%96%B4%EC%9A%94
 */
export const useAppLaunch = () => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const launchApp = useCallback((subdomain?: string) => {
    // (1) 주어진 딥링크로 앱을 실행한다
    window.location.href = subdomain
      ? EMobileAppDeeplink.CommunityJoin.replace("{{SUBDOMAIN}}", subdomain)
      : EMobileAppDeeplink.Root;

    // (2) 일정한 시간동안 앱이 실행되지 않으면 특정 기능을 실행하는 timeout을 생성한다
    timerRef.current = setTimeout(() => {
      const platform = detectMobilePlatform();

      if (platform === EPlatform.Ios) {
        if (confirm("'App Store'에서 열겠습니까?")) {
          openWindow(APP_LINK.APPLE_STORE);
        }
      } else {
        openWindow(APP_LINK.GOOGLE_PLAY);
      }
    }, TIMEOUT_MS);
  }, []);

  useEffect(() => {
    const handlerVisibilityChange = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };

    // (3) window의 visibilitychange 이벤트가 발생하면 앱이 실행됐다고 가정한다. timeout을 제거한다.
    window.addEventListener("visibilitychange", handlerVisibilityChange);

    return () => {
      window.removeEventListener("visibilitychange", handlerVisibilityChange);
    };
  }, []);

  return {
    launchApp,
  };
};
